export default __webpack_public_path__ + "static/media/GSLV-AL-15IN-ST.47bd392f.mp4";